const state = {
  errors: [],
};
const mutations = {
  addError(state, {message , type}) {
    const id = Date.now();
    state.errors.push({ id, message , type});
    setTimeout(() => {
      state.errors = state.errors.filter(error => error.id !== id);
    }, 5000);
  },
  removeError(state, id) {
    state.errors = state.errors.filter(error => error.id !== id);
  },
};

const getters = {
  GET_ERRORS: (state) => state.errors,
}
const actions = {
  triggerError({ commit }, {message , type}) {
    commit('addError', {message , type});
  },
};
export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
}

